<template>
  <l-layout :layout="['xs12']" bottom-space>
    <div class="stats-toolbar">
      <v-tooltip bottom>
        <v-btn slot="activator" icon @click="$router.push({name: 'PassLogList'})">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <span>返回车辆通行日志</span>
      </v-tooltip>
      <h2 class="title">预约车辆统计</h2>
      <v-spacer></v-spacer>
      <v-btn-toggle v-model="preset" class="period-presets">
        <v-btn flat :value="7" @click="setPreset(7)">近7天</v-btn>
        <v-btn flat :value="30" @click="setPreset(30)">近30天</v-btn>
        <v-btn flat :value="90" @click="setPreset(90)">近90天</v-btn>
      </v-btn-toggle>
    </div>

    <v-layout row wrap align-center class="stats-filters">
      <v-flex xs12 sm6 md5>
        <l-select-datetime-duration
          v-model="period"
          :max-duration-day="93"
          label="通行时间"
          @input="preset = null"
        ></l-select-datetime-duration>
      </v-flex>
      <v-flex xs12 sm4 md4>
        <v-autocomplete
          v-model="selectedOrgId"
          :items="orgOptions"
          :filter="orgFilter"
          item-text="name"
          item-value="id"
          label="预约人二级单位"
          clearable
          hide-no-data
        ></v-autocomplete>
      </v-flex>
      <v-flex xs12 sm2 md3 class="stats-commands">
        <v-btn color="primary" :loading="loading" :disabled="exporting" @click="loadSummary">查询</v-btn>
        <v-btn flat color="primary" :disabled="loading || exporting || !displaySummary.length" @click="exportSummary">导出汇总</v-btn>
        <v-btn flat color="primary" :loading="exporting" :disabled="loading || !hasOrgSummary" @click="exportAllVehicles">导出全部单位清单</v-btn>
      </v-flex>
    </v-layout>

    <v-data-table
      :headers="summaryHeaders"
      :items="displaySummary"
      :loading="loading"
      :rows-per-page-items="[10, 20, 50]"
      no-data-text="该时段没有预约车辆通行记录"
      class="elevation-0"
    >
      <template slot="items" slot-scope="props">
        <tr>
          <td>{{ props.item.orgName || props.item.orgId || '未归属单位' }}</td>
          <td>{{ orderTypeName(props.item.orderType) }}</td>
          <td class="text-xs-right">{{ props.item.vehicleCount }}</td>
          <td class="text-xs-right">{{ props.item.passCount }}</td>
          <td class="text-xs-center">
            <v-tooltip bottom v-if="props.item.orgId">
              <v-btn slot="activator" icon @click="selected = props.item">
                <v-icon small>mdi-format-list-bulleted</v-icon>
              </v-btn>
              <span>查看车辆清单</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>

    <l-data-table
      v-if="selected"
      :key="selected.orgId + ':' + selected.orderType + ':' + request.startTime + ':' + request.endTime"
      :headers="vehicleHeaders"
      :get-data-func="getVehicles"
      no-data-text="没有车辆记录"
      class="mt-4"
      clickable
      @click:row="goVehicleDetails"
    >
      <template slot="title">
        <span class="pl-2 pr-4">{{ selected.orgName || selected.orgId }} · {{ orderTypeName(selected.orderType) }}（{{ selected.vehicleCount }}辆）</span>
        <v-spacer></v-spacer>
        <v-btn flat color="primary" :loading="exporting" :disabled="loading" @click="exportVehicles">导出清单</v-btn>
      </template>
    </l-data-table>
  </l-layout>
</template>

<script>
import LDataTable from '../../../ladmin/components/LDataTable/LDataTable'
import LSelectDatetimeDuration from '../../../ladmin/components/LSelectDuration/LSelectDatetimeDuration'
import {time} from '../../../ladmin/utils/time'

export default {
  name: 'VehiclePassStatistics',
  components: {LDataTable, LSelectDatetimeDuration},
  data () {
    return {
      preset: 7,
      period: {},
      request: null,
      selectedOrgId: null,
      summary: [],
      selected: null,
      queryVersion: 0,
      loading: false,
      exporting: false,
      summaryHeaders: [
        {text: '预约人二级单位', value: 'orgName'},
        {text: '预约类型', value: 'orderType'},
        {text: '去重车牌数', value: 'vehicleCount', align: 'right'},
        {text: '通行次数', value: 'passCount', align: 'right'},
        {text: '', value: 'action', sortable: false, align: 'center'}
      ],
      vehicleHeaders: [
        {text: '车辆号牌', value: 'plateNumber', sortable: false},
        {text: '通行次数', value: 'passCount', sortable: false},
        {text: '首次通行', value: 'firstPassTime', sortable: false},
        {text: '末次通行', value: 'lastPassTime', sortable: false}
      ]
    }
  },
  computed: {
    hasOrgSummary () {
      return this.summary.some(row => row.orgId)
    },
    orgOptions () {
      const orgs = new Map()
      this.summary.forEach(row => {
        if (row.orgId) orgs.set(row.orgId, {id: row.orgId, name: row.orgName || row.orgId})
      })
      return Array.from(orgs.values()).sort((a, b) => a.name.localeCompare(b.name, 'zh'))
    },
    displaySummary () {
      return this.selectedOrgId
        ? this.summary.filter(row => row.orgId === this.selectedOrgId)
        : this.summary
    }
  },
  watch: {
    selectedOrgId () {
      this.selected = null
    }
  },
  methods: {
    orgFilter (item, query, name) {
      const search = (query || '').trim().toLocaleLowerCase()
      return !!search && String(name || '').toLocaleLowerCase().includes(search)
    },
    orderTypeName (type) {
      return type === 'order_object' ? '个人预约' : '单位预约'
    },
    setPreset (days) {
      const end = new Date()
      end.setHours(0, 0, 0, 0)
      end.setDate(end.getDate() + 1)
      const start = new Date(end)
      start.setDate(start.getDate() - days)
      this.preset = days
      this.period = {
        startDatetime: time.dateToStr(start, '%Y-%m-%d %H:%M:%S'),
        endDatetime: time.dateToStr(end, '%Y-%m-%d %H:%M:%S')
      }
      this.loadSummary()
    },
    async loadSummary () {
      const version = ++this.queryVersion
      const start = time.toTimeStamp(this.period.startDatetime)
      const end = time.toTimeStamp(this.period.endDatetime)
      if (!start || !end || end <= start || end - start > 93 * 24 * 60 * 60 * 1000) {
        this.loading = false
        this.summary = []
        this.selected = null
        this.$L.alert('error', {message: '请选择不超过93天的通行时间段'})
        return
      }
      this.loading = true
      this.selected = null
      this.summary = []
      try {
        const request = {
          startTime: time.dateToStr(new Date(start), '%Y-%m-%d %H:%M:%S'),
          endTime: time.dateToStr(new Date(end), '%Y-%m-%d %H:%M:%S')
        }
        const rows = await this.$store.dispatch('pass/getVehiclePassSummary', request)
        if (version !== this.queryVersion) return
        if (!Array.isArray(rows)) throw new Error('统计接口返回格式错误')
        this.request = request
        this.summary = rows
        if (!this.orgOptions.some(org => org.id === this.selectedOrgId)) this.selectedOrgId = null
      }
      catch (error) {
        if (version === this.queryVersion) {
          this.$L.alert('error', {message: '统计查询失败：' + error.message})
        }
      }
      finally {
        if (version === this.queryVersion) this.loading = false
      }
    },
    async getVehicles ({pagination}) {
      const data = await this.$store.dispatch('pass/getVehiclePassVehicles', {
        request: {...this.request, orgId: this.selected.orgId, orderType: this.selected.orderType},
        pagination
      })
      return {items: data.content, amount: data.totalElements}
    },
    exportRequest () {
      const start = time.toTimeStamp(this.period.startDatetime)
      const end = time.toTimeStamp(this.period.endDatetime)
      if (!start || !end || end <= start || end - start > 93 * 24 * 60 * 60 * 1000 ||
        !this.request || this.request.startTime !== time.dateToStr(new Date(start), '%Y-%m-%d %H:%M:%S') ||
        this.request.endTime !== time.dateToStr(new Date(end), '%Y-%m-%d %H:%M:%S')) {
        this.$L.alert('error', {message: '请先选择不超过93天的时间范围并查询'})
        return null
      }
      return this.request
    },
    exportSummary () {
      if (!this.exportRequest()) return
      const ExportJsonExcel = require('js-export-excel')
      new ExportJsonExcel({
        fileName: '预约车辆统计',
        datas: [{
          sheetName: '单位汇总',
          sheetHeader: ['预约人二级单位', '预约类型', '去重车牌数', '通行次数'],
          sheetData: this.displaySummary.map(row => [
            row.orgName || row.orgId || '未归属单位', this.orderTypeName(row.orderType),
            row.vehicleCount, row.passCount
          ])
        }]
      }).saveExcel()
    },
    async exportVehicles () {
      const request = this.exportRequest()
      if (!this.selected || !request) return
      await this.exportVehicleRows([this.selected], request, '预约车辆清单')
    },
    async exportAllVehicles () {
      const request = this.exportRequest()
      if (!request) return
      await this.exportVehicleRows(this.summary.filter(row => row.orgId), request, '全部单位预约车辆清单')
    },
    async exportVehicleRows (groups, periodRequest, fileName) {
      if (this.exporting || !groups.length) return
      this.exporting = true
      try {
        const rows = []
        const size = 200
        for (const selection of groups) {
          const request = {...periodRequest, orgId: selection.orgId, orderType: selection.orderType}
          for (let page = 1; ; page++) {
            const data = await this.$store.dispatch('pass/getVehiclePassVehicles', {
              request, pagination: {page, rowsPerPage: size}
            })
            if (!data || !Array.isArray(data.content)) throw new Error('清单接口返回格式错误')
            rows.push(...data.content.map(row => [
              selection.orgName || selection.orgId, this.orderTypeName(selection.orderType),
              row.plateNumber, row.passCount, row.firstPassTime, row.lastPassTime
            ]))
            if (page * size >= data.totalElements || !data.content.length) break
          }
        }
        if (!rows.length) throw new Error('当前时间范围内没有可导出的车辆记录')
        const ExportJsonExcel = require('js-export-excel')
        new ExportJsonExcel({
          fileName,
          datas: [{
            sheetName: '车辆清单',
            sheetHeader: ['预约人二级单位', '预约类型', '车辆号牌', '通行次数', '首次通行', '末次通行'],
            sheetData: rows
          }]
        }).saveExcel()
      }
      catch (error) {
        this.$L.alert('error', {message: '导出失败：' + error.message})
      }
      finally {
        this.exporting = false
      }
    },
    goVehicleDetails ({item}) {
      if (!document.getSelection().toString()) {
        this.$router.push({name: 'VehicleStatisticDetails', params: {plate: item.plateNumber}})
      }
    }
  },
  created () {
    this.setPreset(7)
  }
}
</script>

<style scoped>
.stats-toolbar, .stats-filters, .stats-commands {
  display: flex;
  align-items: center;
}
.stats-toolbar {
  flex-wrap: wrap;
  gap: 8px;
}
.stats-filters {
  margin: 8px 0 16px;
}
.stats-commands {
  flex-wrap: wrap;
}
.period-presets {
  max-width: 100%;
}
</style>
